module.exports = __webpack_public_path__ + "img/icones_elm.2732cc30.png";